import './FindUs.css';
import findusmap from '../../assets/Findus-renz.png';

const FindUs = () => {
    return (
        <div className='findus-container'>
            <h2>Location TBD</h2>
            {/* <img src={findusmap} alt="Find Us Map" /> */}
        </div>
    )
}

export default FindUs;
